import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { IAssignmentRemark } from "../../utils/types/models";

export default createEntityReducer<IAssignmentRemark>(Endpoint.AssignmentRemarks);
